import {
    createApi,
    BaseQueryApi,
    BaseQueryFn,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryError
} from '@reduxjs/toolkit/dist/query/react';
import { RootState } from '../store';
import { sessionActions } from './session.slice';
import { apiBaseUrl } from '../utils/urls';

export const CSRF_TOKEN_PATH = '/auth/v1/csrftoken';

interface CsrfToken {
    csrfToken: string;
}

const prepareHeaders = (headers: Headers, { getState, endpoint }: Pick<BaseQueryApi, 'getState' | 'endpoint'>) => {
    const { csrfToken } = (getState() as RootState).session;

    if (csrfToken) {
        headers.set('X-Csrf-Token', csrfToken);
    }

    // By passing form data as body, rtk-query figures out that its multipart/form-data and handles it
    // as expected by setting content-type to 'multipart/form-data'. Since we have this custom code to
    // set the content-type and there isn't currently a better way to identity if its form-data we have
    // this logic to filtering by endpoint. This is the ONLY endpoint that uploads multipart/form-data.
    // If and when that changes we should consider a different approach.
    if (endpoint !== 'uploadProfileImage') {
        headers.set('Content-Type', 'application/json');
    }

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: apiBaseUrl,
    credentials: 'include',
    prepareHeaders
});

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions: any = {}
) => {
    const { csrfToken } = (api.getState() as RootState).session;

    if (!csrfToken) {
        const csrfResult = await baseQuery(CSRF_TOKEN_PATH, api, extraOptions);
        if (csrfResult.data) {
            api.dispatch(sessionActions.updateCsrfToken({ csrfToken: (csrfResult.data as CsrfToken).csrfToken }));
        }
    }

    return baseQuery(args, api, extraOptions);
};

export const emptySplitApi = createApi({
    baseQuery: baseQueryWithAuth,
    endpoints: () => ({})
});
